<template>
    <div>
        <Card style="width:450px">
            <p slot="title">Pending Info </p>
            <Button slot="extra" size="small" @click="goToPaymentPendingList()">Cancel</Button>

            <Spin v-if="isLoading" size="large"></Spin>
            <template v-else>
                <Row type="flex" justify="center" align="middle" class="code-row-bg">
                    <Col span="10">
                    {{ paymentPending.transactionDate | dateFormatted }}
                    <h5>{{ paymentPending.bankAccountName }}</h5>
                    </Col>
                    <Col span="12" offset="2" style="text-align:right">
                    <Tag v-if="isSpecialMarking" type="border" color="blue"> {{ paymentPending.amount | currencyInter }}
                        <span v-show="paymentPending.currency">({{ amountIdr | currency }})</span>
                    </Tag>
                    <Tag v-else type="border" color="blue"> {{ paymentPending.amount | currency }} </Tag>
                    </Col>
                </Row>
            </template>
        </Card>
    </div>
</template>

<script>
import { HTTP } from '../http-lib';
const numeral = require('numeral');

export default {
    props: {
        paymentPendingId: Number,
        isSpecialMarking: Boolean,
    },
    data: () => ({
        paymentPending: Object,
        isLoading: true,
        amountIdr: 0,
    }),
    methods: {
        getPaymentPending: function () {
            let urlFindByFilter = 'paymentPending/id/' + this.paymentPendingId;
            HTTP
                .get(urlFindByFilter)
                .then(response => {
                    let value = response.data
                    this.paymentPending = {
                        id: value.id,
                        amount: value.amount,
                        transactionDate: value.transactionDate,
                        bankAccountName: value.bank_account.accountName,
                        currency: value.currency_sgd,
                    }

                    if (this.isSpecialMarking) {
                        this.amountIdr = value.amount //* value.currency_sgd.currencyrate
                    } else {
                        this.amountIdr = value.amount
                    }

                    this.isLoading = false
                })
                .catch(e => {
                    console.info('Error', e)
                    this.isLoading = false
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        goToPaymentPendingList: function () {
            // this.$router.push({ path: '/payment/paymentPending/list-data/search/-' })
            this.$router.push({ path: `/payment/paymentPending/list-data/search/${Date.now()}` })
        },

    },
    filters: {
        currency: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0')
        },
        currencyInter: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0.00')
        },
    },
    watch: {},

    created() {
        this.getPaymentPending();

        console.info('isSpecialMarking test', this.paymentPending)
    }
};
</script>
<style></style>



// WEBPACK FOOTER //
// PaymentPendingRowCard.vue?03b0378d